module.exports = __webpack_public_path__ + "img/13.aeed7076.svg";